<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar Menu -->
      <ul class="sidebar-menu">
        <li class="header"><strong>Menu</strong></li>
        <li class="treeview menu-open">
          <a href="#">
            <i class="fa fa-pie-chart"></i>
            <span>Relatórios</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu" v-bind:style="reportsMenuStyle">
            <router-link :to="{ name: 'QuizReports' }" tag="li"><a><i class="fa fa-bar-chart"></i>Questionários</a></router-link>
            <li class="treeview">
              <a href="#">
                <i class="fa fa-align-center"></i>
                <span>Segmentados</span>
                <span class="pull-right-container">
                  <i class="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul class="treeview-menu" v-bind:style="reportsMenuStyle">
                <router-link :to="{ name: 'SegmentedChartsReports' }" tag="li"><a><i class="fa fa-line-chart"></i> <span>Gráficos</span></a></router-link>
                <router-link :to="{ name: 'SegmentedTextualReports' }" tag="li"><a><i class="fa fa-file-text-o"></i> <span>Textuais</span></a></router-link>
              </ul>
            </li>
          </ul>
        </li>
        <router-link :to="{ name: 'Parks' }" tag="li" exact><a><i class="fa fa-tree"></i> <span>Parques</span></a></router-link>
        <router-link :to="{ name: 'Partners' }" tag="li" exact><a><i class="fa fa-group"></i> <span>Parceiros</span></a></router-link>
        <router-link :to="{ name: 'NewsHome' }" tag="li" exact><a><i class="fa fa-bullhorn"></i> <span>Notícias</span></a></router-link>
        <router-link :to="{ name: 'MailingHome' }" tag="li" exact><a><i class="fa fa-envelope-o"></i> <span>Envio de e-mails</span></a></router-link>
        <li class="treeview menu-open">
          <a href="#">
            <i class="fa fa-files-o"></i>
            <span>Gerenciador de Conteúdo</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu" v-bind:style="cmsMenuStyle">
            <router-link :to="{ name: 'ParksCms' }" tag="li" exact><a><i class="fa fa-circle-o"></i> Parques Tecnológicos</a></router-link>
            <router-link :to="{ name: 'CompaniesCms' }" tag="li" exact><a><i class="fa fa-circle-o"></i> Empresas</a></router-link>
            <router-link :to="{ name: 'AboutCms' }" tag="li" exact><a><i class="fa fa-circle-o"></i> Institucional</a></router-link>
          </ul>
        </li>
        <router-link :to="{ name: 'QuizPeriod' }" tag="li" exact><a><i class="fa fa-calendar"></i> <span>Período para Resposta</span></a></router-link>
        <router-link :to="{ name: 'ParkQuizValidationList' }" tag="li" exact><a><i class="fa fa-check"></i> <span>Validação de Questionários</span></a></router-link>
        <router-link :to="{ name: 'ParkStageAudit' }" tag="li" exact><a><i class="fa fa-wrench"></i> <span>Manutenção</span></a></router-link>
      </ul>
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>

export default {
  name: 'AdminSidebar',
  computed: {
    cmsMenuStyle () {
      let cmsRouteNames = ['ParksCms', 'CompaniesCms', 'AboutCms']
      return {
        display: cmsRouteNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      }
    },
    reportsMenuStyle () {
      let reportsRoutesNames = ['SegmentedChartsReports', 'SegmentedTextualReports', 'QuizReports']
      return {
        display: reportsRoutesNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AdminSidebar.vue?11956dfb